export const swipeConfidenceThreshold = 10000;
export const SwipePower = (offset: number, velocity: number) => Math.abs(offset) * velocity;

export const AnimationVariants = {
	enter: (direction: number) => ({
		x: direction > 0 ? 200 : -200,
		opacity: 0,
	}),
	center: {
		zIndex: 1,
		x: 0,
		opacity: 1,
	},
	exit: (direction: number) => ({
		zIndex: 0,
		x: direction < 0 ? 200 : -200,
		opacity: 0,
	}),
};
